<template>
    <!-- 担保机构 审核 渠道投标人  -->
    <div class="accessDetail">
        <div class="accessDetail-top">
            <headCom title="企业详情"></headCom>
        </div>
        <div class="accessDetail-content">
            <div class="part1Title">
                <div class="innerBack">
                    <div>基础信息</div>
                    <div class="backPage" @click="backPage" style="cursor:pointer">返回上一页</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-col :span="8" class="innerPart" v-for="(item,index) in proDetail" :key="index">
                        <span class="decClass">{{proDetailDec[index]}}</span>
                        <span v-if="index=='enterpriseType'&&item=='1'"></span>
                        <span v-else-if="index=='enterpriseType'&&item=='2'">1</span>
                        <span v-else-if="index=='beneficiaryCertnoType'||index=='kggdCertnoType'">{{item == '1' ? '身份证' : item=='2'? '营业执照' : ''}}</span>
                        <!-- <span v-else-if="index=='autoInvoiceApply'">{{item == '1' ? '允许' : '禁止'}}</span> -->
                        <span v-else>{{item}}</span>
                    </el-col>
                </el-row>
            </div>

            <div class="part1Title" v-if="agentDetail != null ">
                <div class="innerBack">
                    <div>经办人信息</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-row>
                        <el-col :span="8" class="innerPart" style="align-items: center;" v-for="(item,index) in agentDetail" :key="index" v-if="index != 'operatorFrontCard' && index != 'operatorBackCard'&& index != 'authoFile'&& index != 'preContract' ">
                            <span class="decClass">{{agent[index]}}</span>
                            <span v-if="index !='authoFile' && index !='preContract'">{{item}}</span>
                        </el-col>
                    </el-row>
                    <el-row v-if="pageInfo.certType == 1">
                        <el-col :span="8" class="certificate">
                            <p>
                                <span>身份证照-人像面</span>
                                <el-button class="base-medium-btn" v-if="imageList['o'].fileShow" style="margin-left: 5px;" type="primary" @click="checkOrginImg(imageList['o'])">查看原图</el-button>
                            </p>
                            <div class="certificate-box" v-if="imageList['o'].fileShow ">
                                <img :src="imageList['o'].fileShow" alt @click="review(imageList['o'])">
                            </div>
                        </el-col>
                        <el-col :span="8" class="certificate">
                            <p>
                                <span>身份证照-国徽面</span>
                                <el-button class="base-medium-btn" v-if="imageList['l'].fileShow" style="margin-left: 5px;" type="primary" @click="checkOrginImg(imageList['l'])">查看原图</el-button>
                            </p>
                            <div class="certificate-box" v-if="imageList['l'].fileShow">
                                <img :src="imageList['l'].fileShow" alt @click="review(imageList['l'])">
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="pageInfo.certType == 1">
                        <el-col :span="8" class="innerPart" style="align-items: center;" v-for="(item,index) in agentDetail" :key="index" v-if="index == 'authoFile' || index == 'preContract' ">
                            <span class="decClass">{{agent[index]}}</span>
                            <!-- <span v-if="index !='authoFile' && index !='preContract'">{{item}}</span> -->
                            <el-button class="base-medium-btn" type="primary" v-if="index =='authoFile'" v-for="(item, idx) in authFileData" @click="checkFile('m',item )">下载查看</el-button>
                            <!-- {{imageList['n'].list.length ||0}} -->
                            <el-button class="base-medium-btn" type="primary" v-if="index =='preContract'" v-for="(item, idx) in preContractData" @click="checkFile('n',item )">下载查看</el-button>
                        </el-col>
                    </el-row>
                </el-row>
            </div>

            <div class="part1Title" v-if="bankInformationDetail != null ">
                <div class="innerBack">
                    <div>银行基本户信息</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-col :span="8" class="innerPart" v-for="(item,index) in bankInformationDetail" :key="index">
                        <span class="decClass">{{bankInformation[index]}}</span>
                        <span>{{item}}</span>
                    </el-col>
                    <el-col :span="8" class="certificate">
                        <p>
                            <span>基本户图片</span>
                            <el-button class="base-medium-btn" v-if="imageList['c'].fileShow" style="margin-left: 5px;" type="primary" @click="checkOrginImg(imageList['c'])">查看原图</el-button>
                        </p>
                        <div class="certificate-box">
                            <img v-if="!imageList['c'].fileShow" src="../../../assets/app.png" alt @click="review(imageList['c'])">
                            <img v-if="imageList['c'].fileShow" :src="imageList['c'].fileShow" alt @click="review(imageList['c'])">
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="part1Title">
                <div class="innerBack">
                    <div>证件信息</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-col :span="8" class="certificate" v-for="(item,index) in imageList" :key="index" v-if="['a', 'b', 'k', 'z', 'y'].indexOf(index) !== -1 && item.fileShow">
                        <p>{{item.name}}</p>
                        <div class="certificate-box">
                            <img v-if="!item.fileShow" src="../../../assets/app.png" alt>
                            <img v-if="item.fileShow" :src="item.fileShow" alt @click="review(item)">
                            <el-button class="base-medium-btn" v-if="item.fileShow" style="height: fit-content;" type="primary" @click="checkOrginImg(item)">查看原图</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="part1Title">
                <div class="innerBack">
                    <div>资质证书</div>
                </div>
                <el-row class="proDetailClassss" v-if="qualification.length">
                    <el-col :span="8" class="certificate" v-for="(item,index) in qualification" :key="index" v-if="item.file != '' ">
                        <!-- <p>{{item.certName}}(编号:{{item.certNo}})</p> -->
                        <div class="certificate-box">
                            <img v-if="!item.fileShow" src="../../../assets/app.png" alt>
                            <img v-if="item.fileShow" :src="item.fileShow" alt @click="review(item)">
                            <el-button class="base-medium-btn" style="height: fit-content;" type="primary" @click="checkOrginImg(item)">查看原图</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="part1Title">
                <div class="innerBack">
                    <div>企业认证协议</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-col :span="8" class="certificate" v-for="(item,index) in imageList" :key="index" v-if="index == 'contractUrl' &&  item.file != '' ">
                        <p>{{item.name}}</p>
                        <div class="certificate-box">
                            <img src="@/assets/order/fileDemo.png" alt @click="review(item)">
                            <!-- <img v-if="item.fileShow" :src="item.fileShow" alt="" > -->
                            <el-button class="base-medium-btn" style="height: fit-content;" type="primary" @click="contractBtn(item)">下载</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="part1Title">
                <div class="innerBack">
                    <div>下载文件</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-col :span="8" class="certificate" v-for="(item,index) in imageList" :key="index" v-show="(index == 'i' ||index == 'bhApply') && (item.fileShow || item.fileUrl)">
                        <div class="certificate-box">
                            <img src="@/assets/order/fileDemo.png" alt @click="review(item)">
                            <div>
                                <p>{{item.name}}</p>
                                <el-button class="base-medium-btn" type="primary" @click="contractBtn(item)">下载</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="part1Title" v-if="isexamineType">
                <div class="innerBack">
                    <div>申请区域信息</div>
                </div>
                <el-row class="proDetailClassss">
                    <el-col :span="8" class="certificate" v-for="(item,index) in contactInfoDec" :key="index" v-show="item.file!=''">
                        <div class="certificate-box">
                            <span class="decClass">{{item}}：</span>
                            <span>{{contactInfo[index]}}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="part1Title" v-if="pageInfo.auditStatus ==2">
                <div class="innerBack">
                    <div>审核未通过</div>
                </div>
                <el-row class="proDetailClassss">
                    <p style="margin-top: 20px;">原因：{{pageInfo.reason}}</p>
                </el-row>
            </div>
        </div>

        <div class="mask" v-if="loading" v-loading="loading" element-loading-text="拼命签署中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)"></div>
        <div class="accessDetail-footer" v-if="showBottom">
            <el-button class="base-medium-btn" type="primary" @click="sureAccess" :disabled="userInfo.uptimeController==1">确认通过</el-button>
            <el-button class="base-medium-btn" @click="reject">驳回</el-button>
        </div>
    </div>
</template>

<script>
	import HeadCom from "../headCom"
	export default {
		data() {
			return {
				loading: false,
				imageList: {
					l: {
						name:'经办人身份证国徽面'
					}, 
					o: {
						name:'经办人身份证人像面'
					}, 
					c: {
						name:'基本户认证资料'
					}, 
					b: {
						name:'营业执照'
					},
					a: {
						name:'法人身份证人像面'
					}, 
					k: {
						name:'法人身份证国徽面'
					},
					z: {
						name:'受益人身份证人像面'
					}, 
					y: {
						name:'受益人身份证国徽面'
					},
					m: {
						name:'授权文件',
						// list:[]    //签章协议及授权委托书是多份（list）
 					},
					n: {
						name:'签章协议'
					}, 
					'contractUrl': {
						name:'开通电子签章协议'
					},   
					'bhApply': {
						name:'保函申请及担保委托合同'
					},   
					i: {
						name:'企业认证补充资料'
					}, 
				},
				qualification: [], //资质证书
				showBottom: false,
				proDetailDec: {
					enterpriseName: "企业名称：",
					creditCode: "统一社会信用代码：",
					enterpriseType: "企业类型：",
					establishTm: '成立时间：',
					registerCapital: '注册资金：',
					legalName: "法人代表姓名：",
					certno: "法人代表身份证：",
					legalCertnoTime: "法定代表人身份证号有效期：",
					legalPhone: "法人手机号：",
					legalAddr: "法定代表人联系地址：",
					email: "公司邮箱：",
					phoneNum: "公司电话：",
          registerAddr: "注册地址：",
          beneficiaryName:"受益人名称：",
          beneficiaryCertnoType:"受益人证件类型：",
          beneficiaryCertno:"受益人证件号：",
          beneficiaryCertnoTime:"受益人证件有效期：",
          beneficiaryAddr:"受益人联系地址：",
          kggdName:"控股股东/实际控制人名称：",
          kggdCertnoType:"控股股东/实际控制人证件类型：",
          kggdCertno:"控股股东/实际控制人证件号：",
          kggdCertnoTime:"控股股东/实际控制人证件有效期：",
					// registerAddr: "注册地址详情：",
					lastUpdateTime: '申请时间：',
					// autoInvoiceApply: '授权自动开票：',
				},
				proDetail: {},
				agent: {
					operatorName: "经办人姓名：",
					operatorIdnum: '经办人身份证号：',
					sqblrCertnoTime: '经办人身份证有效期：',
					operatorPhone: "经办人联系电话：",
					operatorEmail: "邮箱地址：",
					operatorAddr: '联系地址：',
					operatorFrontCard: '身份证人像面：',
					operatorBackCard: '身份证国徽面：',
					authoFile: '授权委托书：',
					preContract: '委托签章协议：'
				},
				agentDetail: null,
				bankInformation: {
					basicAccountName: "基本户开户名称：",
					basicAccountNo: '基本户开户账号：',
					openBank: "基本户开户银行："
				},
				bankInformationDetail: null,
				pageInfo: {},
				contactInfo: {},
				contactInfoDec: {
					orgName: '出函机构名称',
					bcrMername: '区域名称'
				}
			}
		},
		computed: {
			preContractData(){
					return this.imageList['n'].list ||[]
			},
			authFileData(){
				return this.imageList['m'].list ||[]
			},
			isexamineType() {
				return (this.$route.query.type == 0||this.$route.query.type == 2) && this.$route.query.fr == 'bid'
			}
		},
		components: {
			HeadCom
		},
		created() {
			if (typeof this.$route.query.flag != 'undefined') {
				if (this.$route.query.flag == 0) {
					this.showBottom = true
				} else {
					this.showBottom = false
				}
			}
		},
		mounted() {
			if (this.userInfo != null) {
				this.requestData()
			}
		},
		methods: {
			// 查看经办人文件
			checkFile(str, _item) {
				// 除授权文件及签字签章协议外，this.imageList[str].fileShow即为本地临时地址
				// 电子签章协议及授权委托书为多份，以传入的_item。fileShow为临时地址
				let _fileShow = ''
				let _fileType = ''
				if(str== 'm' || str== 'n'){
					if(_item.fileShow && _item.fileShow.indexOf('blob:') != -1){
						_fileShow = _item.fileShow
						_fileType = _item.fileType
					}
				}else if(this.imageList[str] && this.imageList[str].fileShow && this.imageList[str].fileShow.indexOf('blob:') != -1){
					_fileShow = this.imageList[str].fileShow
					_fileType = this.imageList[str].fileType
				}
				
				if (_fileShow != '') {
					this.publicMethed.saveFileToLocal(_fileShow, _item.fileName || _item.remark)
				} else {
					this.$message.error('正在下载文件，请稍后')
				}
			},
			requestData() {
				// 渠道送来的
				// 投标人关联
				if (this.$route.query.fr == 'channal' || this.$route.query.type == 0||this.$route.query.type == 2) {
					let data = {
						enterpriseId: this.$route.query.id,
						guaranteeId: this.userInfo.enterpriseId
                    }
                    if(this.$route.query.type == 2){
                        data.bidderOrderNo = this.$route.query.bidderOrderNo
                    }
					this.requestAPI.selEnterpriseInfoDetail(data).then((res) => {
						let tem = res.data
						// 如果是担保机构,且type为0（自主注册关联），flag表示关联结果，0待审核
						if (this.$route.query.fr == 'channal') {
							if (tem.basicFlag == 1) {
								this.showBottom = true
							}
						} else if (this.$route.query.fr == 'bid') {
							if (this.$route.query.type == 0||this.$route.query.type == 2) {
								this.requestContact()
							}
						}
						let temList = []
						tem.enterpriseFiles.forEach((item,index)=>{
							let temData =  item
							temData['type'] = item['fileType']
							temList.push(temData)
                        })
						temList.push({
							type: "contractUrl",
							fileUrl: tem.contractUrl,
							remark: "电子签章协议",
                        })
						this.handleFile(temList)

						this.pageInfo = tem
						if (this.pageInfo.enterpriseCerts) {
							this.qualification = []
							this.pageInfo.enterpriseCerts.forEach((item, index) => {
								// console.log(item)
								this.qualification.push({
									certName: item.certName,
									certNo: item.certNo,
									name: '资质证书',
									type: 'qualification' + index,
									file: item.certUrl,
									fileUrl: item.certUrl,
									fileShow: ''
								})
							})
							this.handleFile(this.qualification)
						}
						this.bankInformationDetail = {}
						for (let key in this.bankInformation) {
							this.bankInformationDetail[key] = tem[key]
						}
						this.proDetail = {}
						for (let key in this.proDetailDec) {
							this.proDetail[key] = tem[key]
						}
						let establishTm = tem.establishTm.split(' ')[0]
						if (tem.establishTm) {
							this.$set(this.proDetail, 'establishTm', establishTm)
						} else {
							this.$set(this.proDetail, 'establishTm', '')
						}

						this.agentDetail = {}
						for (let key in this.agent) {
							this.agentDetail[key] = tem[key]
						}
					})
				} else {
					let data = {}
					data['type'] = this.$route.query.type
					data['channelId'] = this.$route.query.id
					this.requestAPI.particular(data).then((res) => {
						let tem = res.data
						if (tem.auditStatus == 0 && this.userInfo.userType == 2 &&
							(this.userInfo.sonFlag == 0 || this.userInfo.personnel == 1)) {
							this.showBottom = true
						} else {
							this.showBottom = false
						}
						this.pageInfo = tem
						// 委托担保合同
						Array.isArray(tem.enterpriseFiles) && tem.enterpriseFiles.forEach((item) => {
							item['type'] = item.fileType
							this.$set(this.imageList, item.fileType, item)
                        })
						this.handleFile(this.imageList)


						if (this.$route.query.fr == 'bidDetail') {
							this.bankInformationDetail = {}
							this.bankInformationDetail = {
								basicAccountName: tem.basicAccountName,
								basicAccountNo: tem.basicAccountNo,
								openBank: tem.openBank
							}
							this.agentDetail = {}
							this.agentDetail = {
								operatorName: tem.phoneNum,
								operatorPhone: tem.operatorPhone,
								operatorIdnum: tem.operatorIdnum,
							}
						}
						this.proDetail = {}
						for (let key in this.proDetailDec) {
							if (tem[key] != null) {
								this.proDetail[key] = tem[key]
							}
						}
						this.$set(this.proDetail, 'enterpriseType', tem.enterprlseType)
					})
				}
			},
			requestContact() {
				if (typeof this.$route.query.bgId == 'undefined') {
					return
				}
				this.requestAPI.getBidderGaranteeInfo({
					bgId: this.$route.query.bgId
				}).then((res) => {
					this.contactInfo = res.data
					let tem =  this.imageList['bhApply']
					tem['fileUrl'] = this.contactInfo.hadoopContract +'_application/pdf'
					tem['type'] = 'bhApply'
					this.$set(this.imageList,'bhApply',tem)
					this.handleFile(this.imageList)
					if (this.userInfo.userType == 2 &&
						(this.userInfo.sonFlag == 0 || this.userInfo.personnel == 1)) {
						if (this.contactInfo.signFlag == 0) {
							this.showBottom = true
						} else {
							this.showBottom = false
						}
					}
				})
			},
			handleFile(tem1) {
				this.publicMethed.promiseReFile(tem1, (res) => {
					if (res.fileShow == '') {
						console.log(res)
						return
					}
					if(this.imageList.hasOwnProperty(res.type)){
						if(res.type == 'n' || res.type == 'm'){
							// console.log(res.type,res)
							// 如果是授权协议和电子签章协议盖章文件 ，则可以显示多份
							let _temData = this.imageList[res.type]
							let listData = _temData['list'] || []
							listData.push({
								fileShow:res.fileShow,
								fileType:res.fileType,
								fileUrl:res.fileUrl,
								fileName:res.fileName,
								remark:res.remark
							})
							this.$set(_temData, 'list', listData)
							this.$set(this.imageList, res.type, _temData)
						}else{
							let temData = this.imageList[res.type]
							this.$set(temData, 'fileShow', res.fileShow)
							this.$set(temData, 'fileType', res.fileType)
							this.$set(temData, 'fileUrl', res.fileUrl)
							this.$set(temData, 'fileName', res.fileName)
							this.$set(temData, 'remark', res.remark)
							this.$set(this.imageList, res.type, temData)
						}
						return
					}else{
						this.qualification.forEach((item1, index1) => {
							if (res.type == item1.type && res.fileUrl == item1.fileUrl) {
								item1.fileShow = res.fileShow
								item1['fileType'] = res.fileType
								return
							}
						})
                    }
                    // console.log(this.imageList)
					
				})
			},
			checkOrginImg(Obj){
				if (Obj.fileShowOrgin) {
					window.open('./showImage.html?img=' + Obj.fileShow)
				}else{
					let data = {
						fileUrl: Obj.fileUrl
					}
					this.publicMethed.downLoadImageC(data, (res, type) => {
						if (Obj.type == 'i' && (type == '' || type == 'application/octet-stream')) {
							type = 'application/rar'
						}
						this.$set(Obj, 'fileShow', res)
						this.$set(Obj, 'fileType', type)
						this.$set(Obj, 'fileShowOrgin', 1)
						if (type == "application/pdf") {
							window.open('./pdf/web/viewer.html?file=' + res,
								"_blank")
						} else if (type.indexOf('image') != -1) {
							window.open('./showImage.html?img=' + res)
						}
					}, null,0)
				}
			},
			review(Obj) {
				if (Obj.fileShow) {
					if (Obj.fileType == "application/pdf") {
						window.open('./pdf/web/viewer.html?file=' + Obj.fileShow,
							"_blank")
					} else if (Obj.fileType.indexOf('image') != -1) {
						window.open('./showImage.html?img=' + Obj.fileShow)
					}
				}else{
					let data = {
						fileUrl: Obj.fileUrl
					}
					this.publicMethed.downLoadImageC(data, (res, type) => {
						if (Obj.type == 'i' && (type == '' || type == 'application/octet-stream')) {
							type = 'application/rar'
						}
						this.$set(Obj, 'fileShow', res)
						this.$set(Obj, 'fileType', type)
						if (type == "application/pdf") {
							window.open('./pdf/web/viewer.html?file=' + res,
								"_blank")
						} else if (type.indexOf('image') != -1) {
							window.open('./showImage.html?img=' + res)
						}
					}, null)
				}
			},
			contractBtn(Obj) {
				if (Obj.fileShow && Obj.fileType) {
					// 区分rar及zip,兼容 name为空的情况，正常name为  demo.zip
					let name = this.pageInfo.enterpriseName + Obj.name
					let type = Obj.fileType
					if (type == '' || type == 'application/octet-stream') {
						type = 'application/rar'
					}
					let result = Obj.name.split('.')
					if(Obj.name.indexOf('.') == -1 || result[result.length-1] != 'rar' && result[result.length-1] != 'zip'){
						name = name+'.'+ type.split('/')[1]
					}
					
					this.publicMethed.saveFileToLocal(Obj.fileShow, name)
				} else {
					let data = {
						fileUrl: Obj.fileUrl
					}
					this.publicMethed.downLoadImageC(data, (res, type) => {
						if (Obj.type == 'i' && (type == '' || type == 'application/octet-stream')) {
							type = 'application/rar'
						}
						this.$set(Obj, 'fileShow', res)
						this.$set(Obj, 'fileType', type)
						let name = Obj.name
						let result = Obj.name.split('.')
						if(result[result.length-1] != 'rar' && result[result.length-1] != 'zip'){
							name = name+'.'+ type.split('/')[1]
						}
						this.publicMethed.saveFileToLocal(res, this.pageInfo.enterpriseName + name)
					}, null)
				}

			},
			reject() {
				this.$prompt('请输入拒绝理由', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputErrorMessage: '理由不可为空！'
				}).then(({
					value
				}) => {
					if (this.$route.query.fr == 'bid') {
						// 
						// 自主注册的投标人，签署协议,被担保机构驳回
						if (this.$route.query.type == 0||this.$route.query.type == 2) {
							let data = {
								bidderId: this.$route.query.id,
								userNo: this.userInfo.userId,
								guaranteeId: this.userInfo.enterpriseId,
								remark: value,
								contractType: 0,
								acId: this.contactInfo.acId
							}
							this.requestAPI.rejectContract(data).then((res) => {
								this.$message({
									message: '操作成功！',
									type: 'success'
								});
								this.showBottom = false
							})
						} else {
							// 渠道录入的投标人 被担保机构驳回
							let data = {
								userId: this.userInfo.userId,
								personnel: this.userInfo.personnel,
								creditCode: this.pageInfo.creditCode,
								auditStatus: 2,
								reason: value
							}
							this.requestAPI.channelAudit(data).then((res) => {
								this.$message({
									message: '操作成功！',
									type: 'success'
								});
								this.showBottom = false
							})
						}
					} else {
						let data = {
							enterpriseId: this.$route.query.id,
							remark1: value
						}
						this.requestAPI.channelApprovingReject(data).then((res) => {
							if (res.data == 0) {
								this.showBottom = false
								this.$message({
									message: '操作成功！',
									type: 'success'
								});
							}
						})
					}
				}).catch(() => {});
			},
			sureAccess() {
				if (this.$route.query.fr == 'bid') {
					if (this.$route.query.type == 0||this.$route.query.type == 2) {
						//自主注册的投标人关联
						// return 
						let data = {
							bidderId: this.pageInfo.enterpriseId,
							userNo: this.userInfo.userId,
							userType: 2,
							guaranteeId: this.userInfo.enterpriseId,
							acId: this.contactInfo.acId
						}
						this.loading = true
						this.requestAPI.signContract(data).then((res) => {

							this.loading = false
							let result = res.data
							// for (let i = 0; i < this.contract.length; i++) {
							// 	if (this.contract[i].type == 'bhApply') {
							// 		this.contract[i].file = result.hadoopFileUrl
							// 		this.contract[i].fileShow = ''
							// 		break
							// 	}
							// }
							// this.handleFile(this.contract)
							this.FinancialFlag = false
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.showBottom = false
						}).catch(() => {
							this.loading = false
						})
					} else {
						let data = {
							userId: this.userInfo.userId,
							personnel: this.userInfo.personnel,
							creditCode: this.pageInfo.creditCode,
							auditStatus: 1,
						}
						this.requestAPI.channelAudit(data).then((res) => {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.showBottom = false
						})
					}
				} else {
					let data = {
						enterpriseId: this.$route.query.id
					}
					this.requestAPI.channelApprovingAgree(data).then((res) => {
						this.$message({
							message: '操作成功！',
							type: 'success'
						});
						this.showBottom = false
					})
				}
			},
			backPage() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style lang='less' scoped>
.accessDetail {
    // margin: 20px 20px;
    .accessDetail-content {
        margin: 20px 20px;
        min-height: calc(100vh - 218px);

        // background: #fff;
        .part1Title {
            /* background-color: white; */
            /* margin-bottom: 20px; */
            margin-bottom: 20px;

            .innerBack {
                height: 55px;
                line-height: 55px;
                background: white;
                font-weight: 600;
                display: flex;
                justify-content: space-between;
                padding: 0 33px;
                border-bottom: 1px solid #e9e9e9;

                .backPage {
                    font-weight: 500;
                    font-size: 14px;
                    color: #1890ff;
                }
            }
        }

        .proDetailClassss {
            // max-height: 400px;
            overflow: auto;
            background-color: white;
            margin: 0px 0px 20px 0px;
            padding: 0px 33px 20px 33px;
            font-size: 14px;

            .certificate {
                padding: 20px 0;

                p {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                }

                .certificate-box {
                    display: flex;
                    margin-top: 10px;

                    img {
                        width: 148px;
                        height: 148px;
                        float: left;
                    }

                    div {
                        float: left;
                        margin-left: 20px;
                    }

                    .el-button {
                        margin-left: 20px;
                        /* height: min-content; */
                    }

                    p {
                        //    float: left;
                        margin-left: 20px;
                        padding-bottom: 20px;
                    }
                }
            }

            .decClass {
                // min-width: 80px;
                white-space: nowrap;
                color: #666666;
            }

            .innerPart {
                display: flex;
                margin-top: 20px;
                line-height: 18px;
                // flex: 1;
            }
        }
    }

    .mask {
        width: 100%;
        /* height: 1000px; */
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        height: calc(100vh);
    }

    .accessDetail-footer {
        bottom: 0;
        right: 0;
        left: 200px;
        /* width: 100%; */
        height: 85px;
        line-height: 50px;
        text-align: center;
        background: #fff;
        line-height: 85px;
        box-shadow: 0 -1px 4px 0 rgba(0, 21, 41, 0.12);
    }
}
</style>
